import {
  FOOTBALL_TEAMS,
  FOOTBALL_SEASON,
  FOOTBALL_GAMES_ABBR_WITH_DATE,
} from '../constants/fields';

export function selectTeam(app, team) {
  app.field(FOOTBALL_TEAMS).selectValues(team, false, false);
}

export function clearTeamField(app) {
  app.field(FOOTBALL_TEAMS).clear();
}

export function selectSeason(app, season) {
  app.field(FOOTBALL_SEASON).selectValues(season, false, false);
}

export function clearSeasonField(app) {
  app.field(FOOTBALL_SEASON).clear();
}

export function selectGames(app, games) {
  const gamesArray = games.map(game => ({ qText: game }));
  app.field(FOOTBALL_GAMES_ABBR_WITH_DATE).selectValues(gamesArray, false, false);
}

export function clearGamesField(app) {
  app.field(FOOTBALL_GAMES_ABBR_WITH_DATE).clear();
}
